module.exports = __webpack_public_path__ + "static/media/dsc_9301.38461b93.jpg";